import { render, staticRenderFns } from "./jira_issues_import_status_app.vue?vue&type=template&id=0a3841d9"
import script from "./jira_issues_import_status_app.vue?vue&type=script&lang=js"
export * from "./jira_issues_import_status_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports